import React from 'react'
import { LoadingOutlined } from '@ant-design/icons'
import { PrimaryButton, ButtonLabel, ButtonSpinner } from './styles'

interface LoadingPrimaryButtonProps {
  loading?: boolean
  disabled?: boolean
  onClick: () => void
  children: React.ReactNode
}

// Spinner replaces the label in place, rather than antd's icon-beside-text, so
// the button doesn't resize between loading and idle.
const LoadingPrimaryButton = ({
  loading,
  disabled,
  onClick,
  children
}: LoadingPrimaryButtonProps) => (
  <PrimaryButton disabled={disabled} onClick={onClick}>
    <ButtonLabel $hidden={loading}>{children}</ButtonLabel>
    {loading && (
      <ButtonSpinner>
        <LoadingOutlined spin />
      </ButtonSpinner>
    )}
  </PrimaryButton>
)

export default LoadingPrimaryButton
